import "@37signals/lexxy"
import { highlightCode } from "@37signals/lexxy/helpers"
import "@hotwired/turbo-rails"
import "./controllers"

document.addEventListener("turbo:load", highlightCode)
